/* unplugin-vue-components disabled */import { render } from "./compXinjiangPop.vue?vue&type=template&id=7f5d452a&scoped=true"
import script from "./compXinjiangPop.vue?vue&type=script&lang=js"
export * from "./compXinjiangPop.vue?vue&type=script&lang=js"

import "./compXinjiangPop.vue?vue&type=style&index=0&id=7f5d452a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f5d452a"]])

export default __exports__